import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './BackButton.module.css';
interface BackButtonProps {
    onClick?: () => void;
    children: React.ReactNode;
}
const BackButton: React.FC<BackButtonProps> = ({ onClick, children }) => {
    const navigate = useNavigate();
    const handleClick = () => {
        if (onClick) {
            onClick();
        } else {
            navigate(-1);
        }
    };
    return (
        <button onClick={handleClick} className={styles.backButton}>
            {children}
        </button>
    );
};
export default BackButton;